<template>
  <div v-if="!isProductFormEmpty" class="pm__options">
    <template v-for="(option, optionIndex) in product.options" :key="optionIndex">
      <div v-if="(option.name === 'Color' && !hideColorOption) || (option.name !== 'Color')" class="pm__option">
        <div v-if="option.name != 'Condition'" class="pm__option-title">
        <span>{{option.name.toUpperCase()}}</span>
        <div class="pm__option-title--selected">
          <span v-if="productForm[option.name]">{{productForm[option.name]}}</span>
          <span v-else >Select {{option.name}}</span>
        </div>
      </div>
      <div v-else class="pm__option-title">
        {{option.name.toUpperCase()}}
        <span class="pm__option-title--selected">{{productForm[option.name]}}</span>
        <span @click="toggleToolTip()" class="pm__option__tooltip-icon" @keydown.enter="toggleToolTip()" tabindex="0" role="button" aria-label="Tooltip">ⓘ</span>
        <div ref="tooltip" class="pm__option__tooltip">
          <div class="pm__option__tooltip__inner-wrapper">
            <button type="button" class="pm__option__tooltip__close" @click="toggleToolTip()" aria-label="Tooltip close button">
              <svg class="pm__option__tooltip-closeIcon">
                <use xlink:href="#close"></use>
              </svg>
            </button>
            <div class="pm__option__tooltip__title">Condition</div>
            <div class="pm__option__tooltip__content">
              <div>
                <p><strong>Excellent:</strong></p>
                <p>Practically new; likely never worn outside</p>
              </div>
              <div>
                <p><strong>Great:</strong></p>
                <p>Trail-tested a few times; minor wear visible</p>
              </div>
              <div>
                <p><strong>Good:</strong></p>
                <p>Used for a season; visible wear</p>
              </div>      
            </div>
          </div>
        </div>
      </div>
      <div v-if="!isSecondTurn" :class="[{'is--color': option.name === 'Color'},{'is--title': option.name === 'Title'},{'is--size': option.name === 'Size'},{'is--other': option.name != 'Size' && option.name != 'Color' && option.name != 'Title'}]">
        <div v-if="optionIndex === 0" class="pm__option-items">
          <div v-if="isOptionSeperator && !product.title.includes('E-Gift Card')" class="pm__option-seperator-wrapper">
            <div v-if="maxPriceOptions.length" class="pm__option-seperator">
              <span class="pm__optionPrice">{{formatPrice(productMaxPrice)}}</span>
              <div class="pm__innerOptions">
                <button 
                  v-for="(innerOption,index) in maxPriceOptions" :key="index"
                  :class="['pm__option-item',
                    {'pm__option-item-image': innerOption[1].image},
                    {'selected' : innerOption[0] === productForm[option.name]},
                    {'is--onesize' : innerOption[0].toLowerCase() === 'one size'}
                  ]" 
                  :data-available="innerOption[1].available"
                  data-stio-gtm-id="PDP: Color Option"
                  data-color-swatch
                  @click="emit('on-option-change',option.name,innerOption[0],optionIndex,product.options.length)"
                >
                  <ImageField v-if="innerOption[1].image" :key="innerOption[1].image" :obj="{'url': innerOption[1].image,'alt':innerOption[1].image.alt,'width':288,'height':356}"/>
                  <span v-else class="pm__option-item-name">{{optionName(option.name,innerOption[0])}}</span>
                </button>
              </div>
            </div>
            <div v-if="minPriceOptions.length" class="pm__option-seperator">
              <span class="pm__optionPrice">{{formatPrice(priceRange)}}</span>
              <div class="pm__innerOptions">
                <button 
                  v-for="(innerOption,index) in minPriceOptions" :key="index"
                  :class="['pm__option-item',
                    {'pm__option-item-image': innerOption[1].image},
                    {'selected' : innerOption[0] === productForm[option.name]},
                    {'is--onesize' : innerOption[0].toLowerCase() === 'one size'}
                  ]" 
                  :data-available="innerOption[1].available"
                  data-stio-gtm-id="PDP: Color Option"
                  data-color-swatch
                  @click="emit('on-option-change',option.name,innerOption[0],optionIndex,product.options.length)"
                >
                  <ImageField v-if="innerOption[1].image" :key="innerOption[1].image" :obj="{'url':innerOption[1].image,'alt':innerOption[1].image.alt,'width':288,'height':356}"/>
                  <span v-else class="pm__option-item-name">{{optionName(option.name,innerOption[0])}}</span>
                </button>
              </div>
            </div>
          </div>
          <div v-else class="pm__innerOptions">
            <button 
              v-for="(value,name,index) in renderFirstOptions" :key="index"
              :class="['pm__option-item',
                {'pm__option-item-image': value.image},
                {'selected' : name === productForm[option.name]},
                {'is--onesize' : name.toLowerCase() === 'one size'}
              ]" 
              :data-available="value.available"
              data-stio-gtm-id="PDP: Color Option"
              data-color-swatch
              @click="emit('on-option-change',option.name,name,optionIndex,product.options.length)"
            >
              <ImageField v-if="value.image" :key="value.image" :obj="{'url':value.image,'alt':value.image.alt,'width':288,'height':356}"/>
              <span v-else class="pm__option-item-name">{{optionName(option.name,name)}}</span>
            </button>
          </div>
        </div>
        <div v-if="optionIndex === 1" class="pm__innerOptions">
          <button 
            v-for="(innerOption,index) in renderSecondOptions" :key="index"
            :class="['pm__option-item',
              {'selected' : innerOption.name === productForm[option.name]},
              {'is--onesize' : innerOption.name.toLowerCase() === 'one size'}
            ]" 
            :data-available="innerOption.available"
            @click="emit('on-option-change',option.name,innerOption.name,optionIndex,product.options.length)"
          >
            <span class="pm__option-item-name">{{optionName(option.name,innerOption.name)}}</span>
          </button>
        </div>
        <div v-if="optionIndex === 2 && additionalPropertyOptions.length" class="pm__innerOptions">
          <div 
            v-for="(property,index) in additionalPropertyOptions" :key="index"
            :class="['pm__option-item',{'selected' : property === productForm[option.name]}]" 
          >
            <a :href="seamHandle(property,productForm[option.name])" class="pm__option-item-name">{{ property }}</a>
          </div>
        </div>
        <div v-else-if="optionIndex === 2 && additionalPropertyOptions.length === 0" class="pm__innerOptions">
          <button 
            v-for="(innerOption,index) in renderThirdOptions" :key="index"
            :class="['pm__option-item',{'selected' : innerOption.name === productForm[option.name]}]" 
            :data-available="innerOption.available"
            @click="emit('on-option-change',option.name,innerOption.name,optionIndex,product.options.length)"
          >
            <span class="pm__option-item-name">{{optionName(option.name,innerOption.name)}}</span>
          </button>
        </div>
      </div>
      </div>
    </template>
  </div>
  <div v-if="productForm.Color && renderFirstOptions[productForm.Color].bis" class="pm__bis-notify">Size sold out? Select the size to be notified</div>
</template>


<script setup>
  import { computed, toRefs, ref, reactive, onMounted } from 'vue';
  import ImageField from '../../global/image.vue';

  const props = defineProps({
    product: {
      type: Object,
      default: () => ({})
    },

    renderFirstOptions: {
      type: Object,
      default: () => ({})
    },

    productForm: {
      type: Object,
      default: () => ({})
    },
    
    isSecondTurn: {
      type: Boolean,
      default: false
    },

    hideColorOption: {
      type: Boolean,
      default: false
    },

    hideUnavailableOption: {
      type: Boolean,
      default: false
    }
  })

  const { product,renderFirstOptions,productForm,isSecondTurn,hideUnavailableOption } = toRefs(props)
  let firstOption = reactive(product.value.options[0]?.name)
  let secondOption = reactive(product.value.options[1]?.name)
  let thirdOption = reactive(product.value.options[2]?.name)
  var customerDiscountVal = ref(0)
  const tooltip = ref(null)
  const emit = defineEmits(['on-option-change'])

  onMounted(() => {
    getCustomerDiscount()
  })

  const isProductFormEmpty = computed(() => {
    return Object.keys(productForm.value).length === 0
  })

  const renderSecondOptions = computed(() => {
    const { options } = product.value;

    if(options.length <= 1 || isProductFormEmpty.value){
      return null;
    }

    const { items } = renderFirstOptions.value[productForm.value[firstOption]];
    const secondKey = productForm.value[secondOption];
    const thirdKey = productForm.value[thirdOption];

    let itemsData;
    if (options.length > 2) {
      const data = items.reduce((set, variant) => {
        const property = variant.option3;
        set[property] = set[property] || { items: [] };
        set[property].items.push(variant);
        return set;
      }, {});

      if (thirdKey && !data[thirdKey]) {
        delete productForm.value[thirdOption];
      }

      itemsData = data?.[thirdKey]?.items || data?.['Regular']?.items || items;
    } else {
      itemsData = items;
    }

    itemsData = hideUnavailableOption.value ? itemsData.filter((item) => item.available) : itemsData;
    const secondLevelOptions = itemsData.reduce((set, variant) => {
      const property = variant.option2;

      if (set.findIndex(ele => ele.name === property) === -1) {
        set.push({
              name: property,
              available: variant.available
            });
      }
      return set;
    }, []);

    if (secondKey && secondLevelOptions.findIndex(ele => ele.name === secondKey) === -1) {
      delete productForm.value[secondOption];
    }

    return secondLevelOptions;
  });


  const renderThirdOptions = computed(() => {
    const { options } = product.value;
    if (options.length <= 2 || isProductFormEmpty.value) {
      return null;
    }

    let { items } = renderFirstOptions.value[productForm.value[firstOption]];
    const secondKey = productForm.value[secondOption];
    const thirdKey = productForm.value[thirdOption];

    items = hideUnavailableOption.value ? items.filter((item) => item.available) : items;
    const thirdLevelOptions = items.reduce((set, variant) => {
      const property = variant.option3;
      const isOption2Match = !secondKey || variant.option2 === secondKey;
      const isDuplicate = set.findIndex(ele => ele.name === property) !== -1;

      if (!isDuplicate && isOption2Match) {
        set.push({
          name: property,
          ...(thirdOption === 'Size' && {available: variant.available})
        });
      }

      return set;
    }, []);

    if (thirdKey && thirdLevelOptions.findIndex(ele => ele.name === thirdKey) === -1) {
      delete productForm.value[thirdOption];
    }

    return thirdLevelOptions;
  });

  const isOptionSeperator = computed(() => {
    return (productMinPrice.value != productMaxPrice.value) && (customerDiscountVal.value <= 0) && product.value.title != 'Stio Classic Mountain Studio Tee'
  })

  const productMinPrice = computed(() => {
    return (Number(product.value.min_price/100))
  })

  const productMaxPrice = computed(() => {
    return (Number(product.value.max_price/100))
  })

  const minPriceOptions = computed(() => {
    return renderFirstOptions.value && 
    Object.entries(renderFirstOptions.value).filter(([key, value]) => value.price != productMaxPrice.value)
  })

  const maxPriceOptions = computed(() => {
    return renderFirstOptions.value && 
    Object.entries(renderFirstOptions.value).filter(([key, value]) => value.price === productMaxPrice.value)
  })

  const priceRange = computed(() => {
    return minPriceOptions.value.length && [...new Set(minPriceOptions.value.map(item => item[1].price))];
  })

  const additionalPropertyOptions = computed(() => {
    return product.value.additional_property_options && product.value.additional_property_options != '' ? product.value.additional_property_options.split(',') : []
  })

  const optionName = (key,value) => {
    return key === 'Size' ? window.formattedSize(value) : value
  }

  const getCustomerDiscount = () => {
    customerDiscountVal.value = window.customerDiscount(product.value.tags)
  }

  const formatPrice = (value) => {
    return window.formattedPrice(value);
  }

  const toggleToolTip = () => {
    tooltip.value[0].classList.toggle('is-active')
  }

  const seamHandle = (property,seam) =>{
    const decodeProperty = property.replace(/\./g,'-')
    const replaceProperty = '-' + seam.replace(/\./g,'-')
    const basedHandle = product.value.handle.replace(replaceProperty.toLowerCase(),'')

    return '/products/' + basedHandle + '-' + decodeProperty.toLowerCase()
  }
</script>